import React, { Component } from "react";
import styled from "styled-components";
import { FormattedMessage, injectIntl } from "react-intl";
import { history } from "util/history";
import PropTypes from "prop-types";
import { envConfig } from "env-config";

class AppFooter extends Component {
    static propTypes = {
        isCCM: PropTypes.bool
    };

    handleClick() {
        history.push("/cookieNotice");
    }
    handleClickPrivacy() {
        let url = "https://www.privatebanking.hsbc.com/privacy-notice/";
        if (envConfig.realm === "CI") {
            url =
                "https://www.privatebanking.hsbc.com/privacy-notice/privacy-notice-for-hsbc-private-banking-ci/";
        }
        window.open(url, "_blank", "noopener,noreferrer");
    }
    render() {
        const { isCCM } = this.props;
        return (
            <Footer className="container-footer">
                <div className="left">
                    {isCCM ? (
                        <div>
                            <span
                                data-testid="footer-container-cookie"
                                className="cookie-notice"
                                onClick={this.handleClick}
                            >
                                <FormattedMessage id="AppFooter.hsbc.cookieNotice" />
                            </span>
                            <span> | </span>
                            <span
                                className="cookie-notice"
                                onClick={this.handleClickPrivacy}
                            >
                                <FormattedMessage id="AppFooter.hsbc.privacyPolicy" />
                            </span>
                        </div>
                    ) : null}
                </div>
                <div className="right">
                    <label href="/hsbc" data-testid="footer-container-text">
                        &copy; <FormattedMessage id="AppFooter.hsbc.text" />{" "}
                        {new Date().getFullYear()}
                    </label>
                </div>
            </Footer>
        );
    }
}

const Footer = styled.div`
    width: 100%;
    font-size: 0.75rem;
    color: #333333;
    height: 60px;
    line-height: 60px;
    font-weight: bolder;
    background-color: #d7d8d6;
    display: flex;
    padding-right: 20px;
    padding-left: 20px;
    justify-content: space-between;
    a {
        color: #fff;
        text-decoration: none;
    }
    .cookie-notice {
        color: #333333;
    }
    .cookie-notice:hover {
        cursor: pointer;
        text-decoration: underline;
    }
`;

export default injectIntl(AppFooter);
